import React, { useState } from 'react';
import { useNavigate } from 'react-router';

export const SearchNavbarForm = () => {
    const navigate = useNavigate();
    const [filter, setFilter] = useState('');

    const handleSearch = (event) => {
        event.preventDefault();

        if (filter.trim() !== '') {
            navigate(`/search?filter=${filter.trim()}`);
        }
    };

    return (
        <form className="col-12 col-lg-auto mb-3 mb-lg-0 me-lg-3" onSubmit={handleSearch}>
            <input
                type="search"
                className="form-control"
                placeholder="Search..."
                onChange={(event) => setFilter(event.target.value)}
            />
        </form>
    );
};
